import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ComplianceInProgressIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      stroke={theme.colors[color]}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 6.04v2.7l1.35 1.35m4.725-2.23V4.532c0-.523-.395-.957-.908-1.046-2.066-.36-3.78-1.158-4.617-1.601a1.18 1.18 0 0 0-1.1 0c-.837.443-2.552 1.242-4.617 1.6-.513.09-.908.524-.908 1.047V7.86c0 4.34 4.413 6.707 5.716 7.311.23.107.487.107.717 0 1.304-.604 5.717-2.971 5.717-7.31"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
ComplianceInProgressIcon.id = 'ComplianceInProgressIcon';
ComplianceInProgressIcon.displayName = 'ComplianceInProgressIcon';
export default ComplianceInProgressIcon;
